import { IconGlobe2Outline18 as Globe } from "nucleo-ui-outline-18"

import { Button, Dialog, Input } from "@productlane/ui"

import { useZeroWorkspace } from "@/lib/zero"
import { useSiteImport } from "./use-site-import"

interface Props {
	isOpen: boolean
	portalInstanceId?: string | null
	onOpenChange: (value: boolean) => void
}

export function HelpCenterSiteImportDialog({
	isOpen,
	portalInstanceId = null,
	onOpenChange,
}: Props) {
	const siteImport = useSiteImport({
		portalInstanceId,
		onStarted: () => onOpenChange(false),
	})
	const workspace = useZeroWorkspace()
	const isHelpCenterPublic = !!workspace?.helpCenterPublic
	const portalName = (workspace?.portalInstances ?? []).find(
		(portal: { id: string }) => portal.id === portalInstanceId,
	)?.name

	return (
		<Dialog
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			title="Import your help center"
			description={
				portalName
					? `Point us at your help center. Every page becomes an article on ${portalName}.`
					: "Point us at your help center. Every page becomes an article your AI agent answers from."
			}
			footer={
				<Button
					isLoading={siteImport.isLoading}
					onClick={() => void siteImport.run()}
				>
					Import
				</Button>
			}
		>
			<div className="mt-3">
				<Input
					name="help-center-url"
					icon={Globe}
					inputClassName="h-9 rounded-lg"
					placeholder="help.acme.com"
					value={siteImport.url}
					errorMessage={siteImport.error}
					autoFocus
					onChange={(event) => siteImport.change(event.target.value)}
					onKeyDown={(event) => {
						if (event.key !== "Enter") return
						event.preventDefault()
						void siteImport.run()
					}}
				/>
				<p className="mt-2 text-[13px] text-tertiary">
					Reading runs in the background.{" "}
					{isHelpCenterPublic
						? "Articles arrive as drafts, so you pick what goes live."
						: "Articles arrive live, ready for the day you turn your help center on."}
				</p>
			</div>
		</Dialog>
	)
}
